export default __webpack_public_path__ + "static/media/feature1_8.85f06169.png";